export interface Invoice {
   invoice: number;
   amount: number;
}

export class Invoice implements Invoice {
   constructor( i: any ) {
      this.invoice = i?.invoice;
      this.amount = i?.amount;
   }
}

export interface PaymentPrefs {
   line_item_max: number;
   total_max: number;
}

export class PaymentPrefs implements PaymentPrefs {
   constructor( p: any ) {
      this.line_item_max = p?.line_item_max ?? 99999;
      this.total_max = p?.total_max ?? 99999;
   }
}

export interface Account {
   name: string;
   number: number;

   message: string;

   prefs: PaymentPrefs;
   invoices: Invoice[];

   override?: number;
}

export class Account implements Account {
   constructor( a: any ) {
      this.name = a?.name ?? '';
      this.number = a?.number;
      this.message = a?.message ?? '';

      this.prefs = new PaymentPrefs( a?.prefs );
      this.invoices = a?.invoices.map( i => new Invoice( i )) ?? [];

      if ( a?.override ) { this.override = a.override; }
   }
}
